<template>
  <div>
    <div id="cover-image">
      <img class="cover" :src="require('@/assets/cover.png')" alt />
      <div id="img-frame" class="text-center mb-1">
        <ts-image-input
          v-tooltip="$t('homePage.browsePhoto')"
          :file="photo ? model.photo : file"
          @input="file => (model.photo = file)"
          @filechange="onFileChange"
          :width="146"
          :height="188"
          crop
          class="photo"
        ></ts-image-input>
        <ts-button
          class="m-t-5 btn-xs"
          color="primary"
          outline
          :disabled="saving"
          :waiting="saving"
          v-if="fileChange"
          @click.prevent="changePhoto"
          >{{ $t('save') }}</ts-button
        >
      </div>
    </div>
    <div class="text-center">
      <span>{{ staff ? staff.emp_id : '' }}</span>
      <h3
        class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary"
      >
        {{ staff ? staff.name_en : '' }}
      </h3>
    </div>
    <ts-card-wrapper>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span>
            {{ $t('homePage.nameKh') }}
          </span>
          <p class="pull-right">{{ staff ? staff.name_kh : '' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.sex') }}
          </span>
          <p class="pull-right">
            {{ staff ? (staff.gender == 1 ? 'Male' : 'Female') : '' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.dateOfBirth') }}
          </span>
          <p class="pull-right">{{ staff ? staff.date_of_birth : '' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.phoneNumber') }}
          </span>
          <p class="pull-right">{{ staff ? staff.phone_number_1 : '' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.email') }}
          </span>
          <p class="pull-right">{{ staff ? staff.email : '' }}</p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.role') }}
          </span>
          <p class="pull-right" v-if="profile.roles">
            <span
              class="badge badge-primary mr-1"
              v-for="(role, index) in profile.roles"
              :key="index"
              >{{ role.name == '*' ? 'Admin' : role.name }}</span
            >
          </p>
        </li>
      </ul>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'staff-profile',
  data() {
    return {
      model: {
        photo: ''
      },
      saving: false,
      fileChange: false,
      file: require('@/assets/user_default.png')
    }
  },
  computed: {
    ...mapState('home/staff', ['profile']),
    staff() {
      if (this.profile.staff_id) {
        return this.profile.employee
      }
      return null
    },
    photo() {
      if (this.profile.staff_id) {
        return (this.model.photo = this.profile.employee.photo)
      }
      return null
    }
  },
  methods: {
    onFileChange: function(event) {
      if (event) {
        this.fileChange = true
      }
    },
    changePhoto() {
      this.saving = true
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        let formData = new FormData()
        formData.append('photo', this.model.photo)
        formData.append('staff_id', this.profile.staff_id)
        return this.$store
          .dispatch('home/staff/uploadPhoto', formData)
          .then(response => {
            this.saving = false
            this.fileChange = false
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.saving = false
          })
      }

      return this.model.photo
    }
  }
}
</script>
<style lang="css" scoped>
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 10px 0 10px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -30%;
}
#img-frame .photo {
  width: 146px;
  object-fit: contain;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
